var React = require('react');

function Stethoscope32px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M28 22.874v1.115c0 4.994-3.738 7.977-10 7.977-5.299 0-9-4.102-9-9.975v-2.124C2.433 18.533 0 4.341 0 3.093 0 .857 2.531.097 4.027 0A1.004 1.004 0 0 1 5.09.932a1.001 1.001 0 0 1-.931 1.062C3.731 2.023 2 2.313 2 3.093 2 5.09 5.029 17.98 10 17.98s8-12.89 8-14.887c0-.78-1.729-1.07-2.157-1.099A1.001 1.001 0 0 1 14.914.93 1.01 1.01 0 0 1 15.975 0C17.47.097 20 .857 20 3.093c0 1.248-2.431 15.456-9 16.785v2.113c0 4.697 2.879 7.977 7 7.977 2.987 0 8-.777 8-5.979v-1.115a5.006 5.006 0 0 1-4-4.894 5.004 5.004 0 0 1 5-4.996c2.757 0 5 2.242 5 4.996a5.006 5.006 0 0 1-4 4.894zm-1-7.891c-1.654 0-3 1.344-3 2.997a3.002 3.002 0 0 0 3 2.997c1.654 0 3-1.344 3-2.997a3.002 3.002 0 0 0-3-2.997z","key":1})]);
}

Stethoscope32px.displayName = "Stethoscope32px";

Stethoscope32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 31.97"};

module.exports = Stethoscope32px;

Stethoscope32px.default = Stethoscope32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/stethoscope-32px.svg
// module id = 1112
// module chunks = 0